import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import Questionnaire1Screen from '~/pages/homes/emergency-contraception/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/emergency-contraception/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/emergency-contraception/Questionnaire3Screen';
import Questionnaire8Screen from '~/pages/homes/emergency-contraception/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/emergency-contraception/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/emergency-contraception/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/emergency-contraception/Questionnaire11Screen';
import Questionnaire12Screen from '~/pages/homes/emergency-contraception/Questionnaire12Screen';
import Questionnaire13Screen from '~/pages/homes/emergency-contraception/Questionnaire13Screen';
import Questionnaire4Screen from '~/pages/homes/emergency-contraception/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/emergency-contraception/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/emergency-contraception/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/emergency-contraception/Questionnaire7Screen';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {EMERGENCY_CONTRACEPTION_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const EmergencyContraception = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case EMERGENCY_CONTRACEPTION_KEYS.START:
        trackPageViewGA('/ec/start', 'MDQ-EC - Start');
        return <Questionnaire1Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.PROFILE:
        trackPageViewGA('/ec/profile', 'MDQ-EC - Profile');
        return <Questionnaire2Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.INVALID:
        trackPageViewGA('/ec/invalid', 'MDQ-EC - Invalid');
        return <Questionnaire3Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.EMERGENCY_CONTRACEPTION_USED:
        trackPageViewGA('/ec/emergency-contraception-used', 'MDQ-EC - Emergency Contraception Used');
        return <Questionnaire4Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.LAST_UNPROTECTED_INTERCOURSE:
        trackPageViewGA('/ec/last-unprotected-intercourse', 'MDQ-EC - Last Unprotected Intercourse');
        return <Questionnaire5Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.LAST_PERIOD_AT:
        trackPageViewGA('/ec/last-period-at', 'MDQ-EC - Last Period At');
        return <Questionnaire8Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH:
        trackPageViewGA(
          '/ec/had-blood-pressure-measured-last-6-month',
          'MDQ-EC - Had Blood Pressure Measured Last 6 Month',
        );
        return <Questionnaire9Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.MEDICAL_HISTORY:
        trackPageViewGA('/ec/medical-history', 'MDQ-EC - Medical History');
        return <Questionnaire10Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.MEDICATION_BEING_TREATED:
        trackPageViewGA('/ec/medication-being-treated', 'MDQ-EC - Medication Being Treated');
        return <Questionnaire11Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.NEGATIVE_BIRTH_CONTROL:
        trackPageViewGA('/ec/negative-birth-control', 'MDQ-EC - Negative Birth Control');
        return <Questionnaire12Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.OTHER_MEDICAL_HISTORY:
        trackPageViewGA('/ec/other-medical-history', 'MDQ-EC - Other Medical History');
        return <Questionnaire13Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.PREFERRED_BRAND:
        trackPageViewGA('/ec/preferred-brand', 'MDQ-EC - Preferred Brand');
        return <Questionnaire6Screen />;
      case EMERGENCY_CONTRACEPTION_KEYS.PURCHASE_PREGNANCY_TEST:
        trackPageViewGA('/ec/purchase-pregnancy-test', 'MDQ-EC - Purchase Pregnancy Test');
        return <Questionnaire7Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default EmergencyContraception;
